import { useBrowserOnly } from "app/main/hooks";
import React from "react";
import { inlineScript, calcTransform, getItems } from "./functions";
import { StaticItems } from "./StaticItems";
import { ItemComponent } from "./ItemComponent/ItemComponent";

import "./style.inline.scss";
import { ThirdLevelNavigation } from "app/frame/ThirdLevelNavigation";

export const Navigation = () => {
    const mainNavRef = React.createRef() as React.RefObject<HTMLElement>;
    const newsSectionRef = React.createRef() as React.RefObject<HTMLElement>;

    const browser = useBrowserOnly();
    const items = getItems();
    const [moved, setMoved] = React.useState<number | null>(null);
    const naviContent =
        items == null ? [] : items.map(item => <ItemComponent key={item.url} {...item} moved={moved} />);

    naviContent.unshift(
        <span key="navdi" className="navdi">
            News
        </span>
    );

    if (browser) {
        naviContent.unshift(
            <a href="https://www.t-online.de/" key={"navihome"} className="home hideSmartphone" data-ga-label="home">
                Home
            </a>
        );

        const html = document.getElementsByTagName("html")[0];
        html.classList.remove("showMainNav");
    }

    const handleMove = () => {
        const mainNav = mainNavRef.current as HTMLElement;
        const newsSection = newsSectionRef.current as HTMLElement;

        if (!mainNav || !newsSection) {
            return;
        }

        const mainNavWidth = mainNav.getBoundingClientRect().width;
        const newsSectionWidth = newsSection.getBoundingClientRect().width;
        const diff = Math.abs(Math.round(mainNavWidth - newsSectionWidth));

        if (moved) {
            setMoved(null);
            return;
        }

        setMoved(diff);
    };

    const handleMobileClick = () => {
        const html = document.getElementsByTagName("html")[0];
        html.classList.toggle("showMainNav");
    };

    return (
        <React.Fragment>
            <button className="mainNavButton" onClick={handleMobileClick}>
                <span>Navigation anzeigen</span>
            </button>
            <nav
                ref={mainNavRef}
                className={`mainNav mainNavMaster secondLevelVisible${moved ? " moved" : ""}`}
                aria-label="Hauptnavigation"
                data-ga-action="navigation"
                data-ga-category="click"
            >
                <a href="https://www.t-online.de/" className="home" data-ga-label="home">
                    t-online.de Startseite
                </a>
                <a href="https://telekom.de" data-ga-label="telekom.de">
                    Telekom.de
                </a>

                <section
                    className="news"
                    id="newsNavigation"
                    ref={newsSectionRef}
                    style={calcTransform(browser, moved)}
                >
                    {naviContent}
                </section>

                <StaticItems />
                {browser && <button className="move" title="Weitere Bereiche" onClick={handleMove} />}
            </nav>
            <ThirdLevelNavigation items={items} />
            {inlineScript()}
        </React.Fragment>
    );
};
